import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
  faClipboardCheck,
  faClipboardList,
  faBug,
  faPlus,
  faPlusCircle
} from "@fortawesome/free-solid-svg-icons";

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt, faClipboardCheck, faClipboardList, faBug, faPlus, faPlusCircle);

export { FontAwesomeIcon };
